import React, { useContext } from "react";
import { Switch } from "antd";
import { SunOutlined, MoonOutlined } from "@ant-design/icons";
import { ThemeContext } from "../../contexts/ThemeContext";

const Nav = () => {
  const { darkMode, setDarkMode } = useContext(ThemeContext);

  return (
    <div className="flex items-center justify-end px-2">
      <div
        className="flex items-center gap-1.5 rounded-full px-2.5 py-1.5 transition-all duration-300
                   bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm
                   border border-gray-200/70 dark:border-gray-700/70
                   shadow-gh hover:shadow-gh-md"
      >
        <button
          type="button"
          onClick={() => setDarkMode(false)}
          aria-label="Switch to light mode"
          className={`p-1.5 rounded-full transition-all duration-200 ${
            !darkMode
              ? "bg-amber-100 text-amber-500 shadow-sm scale-105"
              : "text-gray-400 dark:text-gray-500 hover:text-amber-400"
          }`}
        >
          <SunOutlined />
        </button>
        <Switch
          checked={darkMode}
          onChange={setDarkMode}
          size="small"
          className="mx-1"
          aria-label="Toggle dark mode"
        />
        <button
          type="button"
          onClick={() => setDarkMode(true)}
          aria-label="Switch to dark mode"
          className={`p-1.5 rounded-full transition-all duration-200 ${
            darkMode
              ? "bg-indigo-500/20 text-indigo-300 shadow-sm scale-105"
              : "text-gray-400 hover:text-indigo-500"
          }`}
        >
          <MoonOutlined />
        </button>
      </div>
    </div>
  );
};

export default Nav;
